import { Navigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

import './styles/App.module.css';
import MoleculeViewer from './components/MoleculeViewer';
import ContactForm from './components/ContactForm';
import PrivacyPolicy from "./components/privacy-policy";

import DiaDEMOverview from './pages/DiaDEMOverview';
import Publications from './pages/Publications';
import CaseStudies from './pages/CaseStudies';
import Company from './pages/Company';
import Team from './pages/Team';
import Careers from './pages/Careers';
import Consultancy from './pages/Consultancy';

import OLEDUseCase from './pages/use-cases/oleds';
import OTFTUseCase from './pages/use-cases/otfts';
import OPVUseCase from './pages/use-cases/opvs';
import FlexibleDisplaysUseCase from './pages/use-cases/flexible-displays';
import OrganicSensorsUseCase from './pages/use-cases/organic-sensors';
import OrganicLasersUseCase from './pages/use-cases/organic-lasers';
import FluorescentDyesUseCase from './pages/use-cases/fluorescent-dyes';
import PhotocatalystUseCase from './pages/use-cases/photocatalysts';
import WearableSensorsUseCase from './pages/use-cases/wearable-sensors';
import ImagingDyesUseCase from './pages/use-cases/imaging-dyes';
import PhotodynamicTherapyUseCase from './pages/use-cases/photodynamic-therapy';
import DSSCUseCase from './pages/use-cases/dsscs';
import OrganicBatteryMaterialsUseCase from './pages/use-cases/organic-battery-materials';
import SolarFuelsUseCase from './pages/use-cases/solar-fuels';
import UpconversionMaterialsUseCase from './pages/use-cases/upconversion-materials';
import NextGenSunscreensUseCase from './pages/use-cases/next-gen-sunscreens';
import MolecularHeatersUseCase from './pages/use-cases/molecular-heaters';


const App = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeFeature, setActiveFeature] = useState(0);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const features = [
    {
      icon: '🔬',
      title: 'Instant Discovery',
      description: 'Access an exhaustive molecular database with precomputed optoelectronic properties.',
      highlight: '50M+ Molecules',
    },
    {
      icon: '🖥️',
      title: 'User-Friendly Computation',
      description: 'Leverage cutting-edge algorithms to predict advanced material properties.',
      highlight: 'Click-and-compute',
    },
    {
      icon: '🔗',
      title: 'Direct Procurement',
      description: 'Purchase any material candidate directly to your lab.',
      highlight: 'Instant Access',
    },
  ];

  const testimonials = [
    {
      name: 'Dr X',
      role: 'Research Director, University of X',
      quote: 'DiaDEM has revolutionized our material discovery process. What used to take months now takes weeks.',
      image: 'https://images.pexels.com/photos/7915879/pexels-photo-7915879.jpeg',
    },
    {
      name: 'Professor X',
      role: 'Materials Science, X',
      quote: "The precision and speed of DiaDEM's screening capabilities are unmatched in the industry.",
      image: 'https://images.pexels.com/photos/7915879/pexels-photo-7915879.jpeg',
    },
  ];

  return (
      <Routes>
        <Route
          path="/"
          element={
            <>
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 text-white">
     {/* Navigation */}
<nav className="fixed top-0 w-full z-50 bg-[#1F1B3A]/90 backdrop-blur-md border-b border-[#EF7C34]/20">
  <div className="max-w-7xl mx-auto px-6 sm:px-8">
    <div className="flex items-center justify-between h-16">
      {/* Logo */}
      <div className="flex items-center space-x-2">
        <img
          src="/Apoello-Text-Orange-No-Pad.png"
          alt="Apoello Logo"
          className="h-6 w-auto object-contain"
        />
      </div>

      {/* Navigation Links */}
      <div className="hidden md:flex items-center space-x-8 relative text-sm font-medium">
        {/* PLATFORM */}
        <div className="group relative">
          <button className="text-slate-300 hover:text-[#F89B3F] transition-colors">
            DiaDEM™ Platform
          </button>
          <div className="absolute left-0 mt-2 w-48 bg-[#2A264A]/95 backdrop-blur-sm rounded-lg shadow-xl border border-[#EF7C34]/20 opacity-0 group-hover:opacity-100 transition-opacity z-50">
            <a href="/diadem-overview" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Overview</a>
<a
  href="https://diadem.readthedocs.io/en/latest/"
  target="_blank"
  rel="noopener noreferrer"
  className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200"
>
  Documentation
</a>
          </div>
        </div>

        {/* RESEARCH */}
        <div className="group relative">
          <button className="text-slate-300 hover:text-[#F89B3F] transition-colors">
            Research
          </button>
          <div className="absolute left-0 mt-2 w-48 bg-[#2A264A]/95 backdrop-blur-sm rounded-lg shadow-xl border border-[#EF7C34]/20 opacity-0 group-hover:opacity-100 transition-opacity z-50">
            <a href="/publications" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Publications</a>
            <a href="/case-studies" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Case Studies</a>
          </div>
        </div>

{/* CONSULTING */}
<div>
  <Link
    to="/consultancy"
    className="text-slate-300 hover:text-[#F89B3F] transition-colors"
  >
    Consultancy
  </Link>
</div>

{/* USE CASES */}
<div className="group relative">
  <button className="text-slate-300 hover:text-[#F89B3F] transition-colors">
    Use Cases
  </button>
  <div className="absolute left-0 mt-2 w-64 bg-[#2A264A]/95 backdrop-blur-sm rounded-lg shadow-xl border border-[#EF7C34]/20 opacity-0 group-hover:opacity-100 transition-opacity z-50 p-2 space-y-2">
    
    {/* Core Electronics */}
    <div>
      <p className="px-4 py-1 text-xs font-semibold text-orange-300 uppercase tracking-wider">Core Electronics</p>
      <a href="/use-cases/oleds" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">OLEDs</a>
      <a href="/use-cases/otfts" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">OTFTs</a>
      <a href="/use-cases/flexible-displays" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Flexible Displays</a>
      <a href="/use-cases/organic-sensors" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Organic Sensors</a>
    </div>

    {/* Advanced Materials */}
    <div>
      <p className="px-4 py-1 text-xs font-semibold text-orange-300 uppercase tracking-wider">Advanced Materials</p>
      <a href="/use-cases/organic-lasers" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Organic Lasers</a>
      <a href="/use-cases/fluorescent-dyes" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Fluorescent & Laser Dyes</a>
      <a href="/use-cases/photocatalysts" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Photocatalysts</a>
    </div>

    {/* Bio & Imaging */}
    <div>
      <p className="px-4 py-1 text-xs font-semibold text-orange-300 uppercase tracking-wider">Bio & Imaging</p>
      <a href="/use-cases/wearable-sensors" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Wearable Sensors</a>
      <a href="/use-cases/imaging-dyes" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Imaging Dyes</a>
      <a href="/use-cases/photodynamic-therapy" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Photodynamic Therapy</a>
    </div>

    {/* Energy */}
    <div>
      <p className="px-4 py-1 text-xs font-semibold text-orange-300 uppercase tracking-wider">Energy</p>
      <a href="/use-cases/opvs" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">OPVs</a>
      <a href="/use-cases/dsscs" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">DSSCs</a>
      <a href="/use-cases/organic-battery-materials" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Organic Battery Materials</a>
      <a href="/use-cases/solar-fuels" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Solar Fuels</a>
      <a href="/use-cases/upconversion-materials" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Upconversion Materials</a>
    </div>

    {/* Photothermal Materials */}
    <div>
      <p className="px-4 py-1 text-xs font-semibold text-orange-300 uppercase tracking-wider">Photothermal Materials</p>
      <a href="/use-cases/molecular-heaters" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Molecular Heaters</a>
      <a href="/use-cases/next-gen-sunscreens" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Next-Gen Sunscreens</a>
    </div>

  </div>
</div>

        {/* ABOUT */}
        <div className="group relative">
          <button className="text-slate-300 hover:text-[#F89B3F] transition-colors">
            About
          </button>
          <div className="absolute left-0 mt-2 w-48 bg-[#2A264A]/95 backdrop-blur-sm rounded-lg shadow-xl border border-[#EF7C34]/20 opacity-0 group-hover:opacity-100 transition-opacity z-50">
            <a href="/company" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Company</a>
            <a href="/team" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Team</a>
            <a href="/careers" className="block px-4 py-2 hover:bg-[#EF7C34]/10 text-slate-200">Careers</a>
          </div>
        </div>

    
      </div>
    </div>
  </div>
</nav>


{/* Molecule Viewer Feature */}
{isVisible && (
  <section className="py-20" style={{ backgroundColor: '#39355A' }} id="molecule">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 flex flex-col lg:flex-row items-center lg:items-start gap-12">
      
      {/* Left: Title and description */}
      <div className="lg:w-1/2 text-left">
        <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight text-white">
          Accelerating<br />
          Organic<br />
          Materials<br />
          <span className="bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent inline drop-shadow-sm">
            Discovery
          </span>
        </h1>
        <p className="text-xl text-slate-100 max-w-xl">
          Our DiaDEM<sup>™</sup> platform transforms months of trial-and-error research into precision-guided discovery. 
          Instantly reveal high-performance materials for organic electronics, solar energy, laser dyes, photocatalysis, imaging diagnostics, phototherapies and more.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-start">
          
          {/* Watch Demo Button */}
          <a
            href="https://www.youtube.com/watch?v=Dr7z33VKtq8"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="bg-[#EF7C34] text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all transform hover:scale-105 shadow-lg hover:shadow-orange-300/50 border border-[#EF7C34] hover:bg-[#6A67A0]">
              Watch demo
            </button>
          </a>

          {/* Contact Us Button */}
          <a href="#contact">
            <button className="border-2 border-white text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all hover:border-[#EF7C34] hover:text-[#F89B3F] hover:bg-white/10">
              Contact us
            </button>
          </a>

        </div>
      </div>
	{/* Right: Molecule viewer */}
	<div className="lg:w-1/2 w-full">
	 <div className="aspect-square w-full max-w-md mx-auto rounded-2xl overflow-hidden" style={{ backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}>
		<MoleculeViewer />
	  </div>
	</div>
    </div>
    
    {/* Scroll Indicator */}
    <div className="mt-16 flex justify-center">
      <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
        <div className="w-1 h-3 bg-white rounded-full mt-2 animate-bounce"></div>
      </div>
    </div>
  </section>
)}


{/* Problem/Solution Section */}
<section className="py-20" style={{ backgroundColor: '#2F2A4A' }}>
  <div className="max-w-7xl mx-auto px-6 sm:px-8">
    <div className="text-center mb-16">
      <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
        From Years to
        <span className="bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent"> Days</span>
      </h2>
      <p className="text-xl text-slate-100 max-w-3xl mx-auto">
        Traditional material discovery relies on costly trial-and-error.
      </p>
      <p className="text-xl text-slate-100 max-w-3xl mx-auto">  DiaDEM<sup>™</sup> is designed to expedite discovery. </p>
    </div>

    <div className="grid md:grid-cols-2 gap-12 items-center">
      {/* Left Side: Comparison Cards */}
      <div className="space-y-8">

        {/* Traditional Box */}
        <div className="bg-gradient-to-br from-[#3B355A]/90 to-[#4A437A]/90 p-8 rounded-2xl border border-[#EF7C34]/30">
          <div className="flex items-center mb-4">
            <div className="w-12 h-12 bg-red-400/20 rounded-lg flex items-center justify-center mr-4">
              <span className="text-red-400 text-2xl">⏰</span>
            </div>
            <h3 className="text-xl font-semibold text-red-400">Traditional Approach</h3>
          </div>
          <ul className="space-y-3 text-slate-200">
            <li className="flex items-center"><span className="text-red-400 mr-2">✗</span>Years of trial-and-error experiments</li>
            <li className="flex items-center"><span className="text-red-400 mr-2">✗</span>Expensive synthesis and characterisation</li>
            <li className="flex items-center"><span className="text-red-400 mr-2">✗</span>Requires many years of expertise</li>
            <li className="flex items-center"><span className="text-red-400 mr-2">✗</span>Unpredictable outcomes</li>
          </ul>
        </div>

        {/* DiaDEM Box */}
        <div className="bg-gradient-to-br from-[#3B355A]/90 to-[#4A437A]/90 p-8 rounded-2xl border border-[#EF7C34]/30">
          <div className="flex items-center mb-4">
            <div className="w-12 h-12 bg-[#726CA0]/20 rounded-lg flex items-center justify-center mr-4">
              <img src="/fav-8.png" alt="DiaDEM icon" className="w-auto h-10" />
            </div>
            <h3 className="text-xl font-semibold text-orange-300">DiaDEM™ Platform</h3>
          </div>
          <ul className="space-y-3 text-slate-100">
            <li className="flex items-center"><span className="text-orange-400 mr-2">✓</span>Instant materials discovery</li>
            <li className="flex items-center"><span className="text-orange-400 mr-2">✓</span>Database calibrated to real experiments</li>
            <li className="flex items-center"><span className="text-orange-400 mr-2">✓</span>Easy click-and-compute predictions for advanced properties</li>
            <li className="flex items-center"><span className="text-orange-400 mr-2">✓</span>Procure any candidate directly to the lab</li>
          </ul>
        </div>

      </div>

      {/* Right Side: Image */}
      <div className="relative">
        <div 
          className="rounded-2xl overflow-hidden shadow-2xl border border-[#EF7C34]/30"
          style={{
            backgroundImage: `url('/scifi-mol-orange.png')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '550px'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-t from-[#2C264A]/75 via-transparent to-[#2C264A]/20"></div>
        </div>
      </div>
    </div>
  </div>
</section>



{/* Features Section */}
<section id="features" className="py-20" style={{ backgroundColor: '#221E3F' }}>
  <div className="max-w-7xl mx-auto px-6 sm:px-8">
    <div className="text-center mb-16">
      <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
        DiaDEM™ Platform
        <span className="bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent block">
          Features
        </span>
      </h2>
      <p className="text-xl text-slate-200 max-w-3xl mx-auto">
        Comprehensive tools for accelerated materials discovery and development
      </p>
    </div>

    <div className="grid md:grid-cols-3 gap-8">
      {features.map((feature, index) => (
        <div
          key={index}
          className={`group relative bg-gradient-to-br from-[#3B355A]/70 to-[#4A437A]/70 backdrop-blur-sm p-8 rounded-2xl border border-white/10 hover:border-[#EF7C34] transition-all duration-300 hover:scale-105 cursor-pointer ${
            activeFeature === index ? 'border-[#EF7C34] bg-[#3B355A]/80' : ''
          }`}
          onMouseEnter={() => setActiveFeature(index)}
        >
          <div className="text-center">
            <div className="w-16 h-16 bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] rounded-xl flex items-center justify-center mx-auto mb-6 group-hover:shadow-lg group-hover:shadow-orange-400/30 transition-all">
              <span className="text-3xl text-white">{feature.icon}</span>
            </div>
            <h3 className="text-xl font-semibold mb-4 text-white">{feature.title}</h3>
            <p className="text-slate-200 mb-6 leading-relaxed">{feature.description}</p>
            <div className="inline-block bg-[#EF7C34]/10 px-4 py-2 rounded-lg border border-[#EF7C34]/30">
              <span className="text-[#EF7C34] font-semibold">{feature.highlight}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>


{/* Video Section */}
<section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden bg-[#1A1631]">
  {/* Gradient overlay to ensure dark tone */}
  <div className="absolute inset-0 bg-gradient-to-br from-[#1A1631]/95 via-[#2B264B]/90 to-[#221E3F]/95 z-10"></div>

  {/* Background image (prevents flash by being layered beneath the gradient) */}
  <div 
    className="absolute inset-0 bg-cover bg-center opacity-20"
    style={{
      backgroundImage: `url('https://images.unsplash.com/photo-1581093577421-f561a654a353')`,
    }}
  ></div>

  {/* Video content */}
  <div className="relative z-20 max-w-5xl mx-auto px-6 sm:px-8 text-center">
    <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight text-white">
      The Future of
      <span className="bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent block pb-3">
        Materials Discovery
      </span>
    </h1>

    <div className="relative w-full max-w-5xl aspect-video mx-auto rounded-2xl overflow-hidden shadow-2xl border border-[#EF7C34]/30">
      <iframe
        className="absolute inset-0 w-full h-full"
        src="https://www.youtube-nocookie.com/embed/E_y9ph9rdLY"
        title="DiaDEM demo"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  </div>
</section>


{/* Stats Section */}
<section className="py-20 bg-[#2A2444]">
  <div className="max-w-7xl mx-auto px-6 sm:px-8">
    <div className="grid md:grid-cols-4 gap-8 text-center">
      <div className="space-y-2">
        <div className="text-4xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">80%</div>
        <div className="text-slate-300">Reduction in R&D spend</div>
      </div>
      <div className="space-y-2">
        <div className="text-4xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">50,000,000+</div>
        <div className="text-slate-300">Molecular database</div>
      </div>
      <div className="space-y-2">
        <div className="text-4xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">5</div>
        <div className="text-slate-300">Institutions supported</div>
      </div>
      <div className="space-y-2">
        <div className="text-4xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">∞</div>
        <div className="text-slate-300">Virtual experiments</div>
      </div>
    </div>
  </div>
</section>



{/* Testimonials Section 
<section className="py-20 bg-[#1A1631]">
  <div className="max-w-7xl mx-auto px-6 sm:px-8">
    <div className="text-center mb-16">
      <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
        Trusted by
        <span className="bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent"> Researchers</span>
      </h2>
      <p className="text-xl text-slate-300">Leading institutions worldwide rely on DiaDEM</p>
    </div>

    <div className="grid md:grid-cols-2 gap-8">
      {testimonials.map((testimonial, index) => (
        <div
          key={index}
          className="bg-gradient-to-br from-[#2B264B]/70 to-[#3A3261]/70 backdrop-blur-sm p-8 rounded-2xl border border-[#EF7C34]/20 shadow-lg"
        >
          <div className="flex items-start space-x-4">
            <img 
              src={testimonial.image} 
              alt={testimonial.name}
              className="w-16 h-16 rounded-full object-cover"
            />
            <div className="flex-1">
              <p className="text-slate-300 mb-4 text-lg italic">"{testimonial.quote}"</p>
              <div>
                <div className="font-semibold text-white">{testimonial.name}</div>
                <div className="text-slate-400">{testimonial.role}</div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>
*/}

{/* Contact Section */}
<section id="contact" className="py-20 bg-[#221E3F]">
  <div className="max-w-4xl mx-auto px-6 sm:px-8 text-center">
    <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
      <span className="bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">Get in Touch</span>
    </h2>
    <p className="text-xl text-slate-300 mb-10">
      Ready to accelerate your research? Let’s talk.
    </p>
    <ContactForm id="contact"/>
  </div>
</section>


{/* Footer */}
<footer className="bg-[#1A1631] py-12 border-t border-[#EF7C34]/20">
  <div className="max-w-7xl mx-auto px-6 sm:px-8">
    <div className="grid md:grid-cols-4 gap-12">
      {/* Logo & Summary */}
      <div className="space-y-4">
        <div className="flex items-center">
	  <img
		src="/Apoello-Text-Orange-No-Pad.png"
		alt="Apoello Logo"
		className="h-8 sm:h-9 md:h-10 w-auto object-contain -ml-5"
	  />
	</div>
        <p className="text-slate-400 leading-relaxed">
          Accelerating organic materials discovery through precision-guided research.
        </p>
        <p className="text-slate-500">Liverpool, UK</p>
      </div>

      {/* Platform */}
      <div>
        <h3 className="font-semibold text-white mb-4 border-b border-[#EF7C34]/30 pb-2">DiaDEM™ Platform</h3>
        <ul className="space-y-2 text-slate-400">
          <li>
            <Link to="/diadem-overview" className="hover:text-[#F89B3F] transition-colors">
              Overview
            </Link>
          </li>
          <li>
            <Link to="https://diadem.readthedocs.io/en/latest/" className="hover:text-[#F89B3F] transition-colors">
              Documentation
            </Link>
          </li>
        </ul>
      </div>

      {/* Research */}
      <div>
        <h3 className="font-semibold text-white mb-4 border-b border-[#EF7C34]/30 pb-2">Research</h3>
        <ul className="space-y-2 text-slate-400">
          <li>
            <Link to="/publications" className="hover:text-[#F89B3F] transition-colors">
              Publications
            </Link>
          </li>
          <li>
            <Link to="/case-studies" className="hover:text-[#F89B3F] transition-colors">
              Case Studies
            </Link>
          </li>
        </ul>
      </div>

      {/* About */}
      <div>
        <h3 className="font-semibold text-white mb-4 border-b border-[#EF7C34]/30 pb-2">About</h3>
        <ul className="space-y-2 text-slate-400">
          <li>
            <Link to="/company" className="hover:text-[#F89B3F] transition-colors">
              Company
            </Link>
          </li>
          <li>
            <Link to="/team" className="hover:text-[#F89B3F] transition-colors">
              Team
            </Link>
          </li>
          <li>
            <Link to="/careers" className="hover:text-[#F89B3F] transition-colors">
              Careers
            </Link>
          </li>
          <li>
            <Link to="/consultancy" className="hover:text-[#F89B3F] transition-colors">
              Consultancy
            </Link>
          </li>
        </ul>
      </div>
    </div>

{/* Footer Bottom Bar */}
<div className="border-t border-[#EF7C34]/20 mt-12 pt-6 text-center text-sm text-slate-500">
  <p className="space-x-2">
    &copy; 2025 Apoello Ltd. All rights reserved.
    <span> · </span>
    <Link to="/privacy-policy" className="underline hover:text-[#F89B3F]">
      Privacy Policy
    </Link>
    <span> · </span>
    <span>
      This website uses strictly necessary cookies for functionality and security. No tracking or advertising cookies are used.
    </span>
  </p>
</div>

  </div>
</footer>

              </div>
            </>
          }
        />

	{/* Other Pages */}
	<Route path="/diadem-overview" element={<DiaDEMOverview />} />
  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
	<Route path="/documentation" element={<Navigate to="https://diadem.readthedocs.io/en/latest/" replace />} />
	<Route path="/publications" element={<Publications />} />
	<Route path="/case-studies" element={<CaseStudies />} />
	<Route path="/company" element={<Company />} />
	<Route path="/team" element={<Team />} />
	<Route path="/careers" element={<Careers />} />
  <Route path="/consultancy" element={<Consultancy />} />
	<Route path="/use-cases/oleds" element={<OLEDUseCase />} />
	<Route path="/use-cases/otfts" element={<OTFTUseCase />} />
	<Route path="/use-cases/opvs" element={<OPVUseCase />} />
	<Route path="/use-cases/flexible-displays" element={<FlexibleDisplaysUseCase />} />
	<Route path="/use-cases/organic-sensors" element={<OrganicSensorsUseCase />} />
	<Route path="/use-cases/organic-lasers" element={<OrganicLasersUseCase />} />
	<Route path="/use-cases/fluorescent-dyes" element={<FluorescentDyesUseCase />} />
	<Route path="/use-cases/photocatalysts" element={<PhotocatalystUseCase />} />
	<Route path="/use-cases/wearable-sensors" element={<WearableSensorsUseCase />} />
	<Route path="/use-cases/imaging-dyes" element={<ImagingDyesUseCase />} />
	<Route path="/use-cases/photodynamic-therapy" element={<PhotodynamicTherapyUseCase />} />
	<Route path="/use-cases/dsscs" element={<DSSCUseCase />} />
	<Route path="/use-cases/organic-battery-materials" element={<OrganicBatteryMaterialsUseCase />} />
	<Route path="/use-cases/solar-fuels" element={<SolarFuelsUseCase />} />
	<Route path="/use-cases/upconversion-materials" element={<UpconversionMaterialsUseCase />} />
  <Route path="/use-cases/molecular-heaters" element={<MolecularHeatersUseCase />} />
  <Route path="/use-cases/next-gen-sunscreens" element={<NextGenSunscreensUseCase />} />
      </Routes>
  );
};

export default App;